export default __webpack_public_path__ + "static/media/client-6.dc13f506.png";